export const preorder = {
  preorder: {
    shape:
      '<path fill="#000" fill-opacity=".51" d="M9.5 20H6.2c-.65 0-1.179-.204-1.587-.613C4.204 18.979 4 18.45 4 17.8V6.2c0-.65.204-1.18.613-1.588C5.021 4.204 5.55 4 6.2 4h3.3v1H6.2c-.383 0-.68.104-.888.312C5.104 5.521 5 5.817 5 6.2v11.6c0 .383.104.68.312.888.209.208.505.312.888.312h3.3v1Zm2 3V1.375h1V23h-1ZM19 5h-.4V4h.4c.283 0 .52.096.712.287.192.192.288.43.288.713v.4h-1V5Zm0 7.875v-1.75h1v1.75h-1ZM19 20h-.4v-1h.4v-.4h1v.4c0 .283-.096.52-.288.712A.965.965 0 0 1 19 20Zm0-10.875V7.4h1v1.725h-1Zm0 7.475v-1.725h1V16.6h-1ZM14.5 20v-1h2.1v1h-2.1Zm0-15V4h2.1v1h-2.1Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
